import React, { Dispatch, SetStateAction, useState } from "react";
import CooperativeFilters from "./CooperativeFilters";
import CooperativeTable from "./CooperativeTable";
import useMobile from "../../hooks/useMobile";
import { useNavigate } from "react-router-dom";
import { ICooperativeFilter } from "../../exports/interfaces";
import { UserRoundPlus } from "lucide-react";

const CooperativeList = ({
  cooperative,
  setCooperative,
}: {
  cooperative: ICooperativeFilter[];
  setCooperative: Dispatch<SetStateAction<ICooperativeFilter[]>>;
}) => {
  const isMobile = useMobile();
  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    search: "",
    regYear: "",
    gender: "",
    municipality: "",
    ward: "",
  });

  const filteredCooperative = cooperative.filter((item) => {
    const searchMatch =
      !filters.search ||
      item.nameEnglish?.toLowerCase().includes(filters.search.toLowerCase()) ||
      item.registrationNumber
        ?.toLowerCase()
        .includes(filters.search.toLowerCase());

    const municipalityMatch =
      !filters.municipality ||
      item.address?.municipality === filters.municipality ||
      item.cooperativeandexecutive?.committeemember?.some(
        (member) => member.municipality === filters.municipality,
      ) ||
      item.cooperativeandexecutive?.executivemember?.some(
        (member) => member.municipality === filters.municipality,
      );

    const wardMatch =
      !filters.ward ||
      item.address?.ward?.toString() === filters.ward ||
      item.cooperativeandexecutive?.committeemember?.some(
        (member) => member.ward?.toString() === filters.ward,
      ) ||
      item.cooperativeandexecutive?.executivemember?.some(
        (member) => member.ward?.toString() === filters.ward,
      );

    const genderMatch =
      !filters.gender ||
      item.cooperativeandexecutive?.executivemember?.some(
        (member) => member.gender === filters.gender,
      );

    const regYearMatch =
      !filters.regYear ||
      item.financial?.share?.fiscalYear === filters.regYear ||
      item.financial?.loan?.fiscalYear === filters.regYear ||
      item.financial?.income?.fiscalYear === filters.regYear ||
      item.financial?.audit?.fiscalYear === filters.regYear ||
      item.financial?.tax?.fiscalYear === filters.regYear;

    return (
      searchMatch &&
      municipalityMatch &&
      wardMatch &&
      genderMatch &&
      regYearMatch
    );
  });

  const registeredCount = cooperative.filter(
    (item) => item.status === "Active",
  ).length;

  const unregisteredCount = cooperative.filter(
    (item) => item.status === "Draft",
  ).length;

  return (
    <>
      <div
        id="cooperatives-list"
        className="d-flex justify-content-between align-items-center mb-3"
      >
        <div>
          <h3>Cooperatives List</h3>
          <small>
            {registeredCount.toString().padStart(2, "0")} REGISTERED,{" "}
            {unregisteredCount.toString().padStart(2, "0")} UNREGISTERED
          </small>
        </div>

        <button
          className="btn px-3 btn-badge"
          onClick={() => navigate("/register-new")}
        >
          <i className={`${!isMobile ? "me-2" : ""}`}>
            <UserRoundPlus size={20} />
          </i>
          {!isMobile && "Register Here"}
        </button>
      </div>
      <CooperativeFilters filters={filters} setFilters={setFilters} />
      <CooperativeTable
        cooperative={filteredCooperative}
        setCooperative={setCooperative}
      />
    </>
  );
};

export default CooperativeList;
